
class CardFilter extends HTMLElement {
    constructor() {

        let filters = document.querySelectorAll(".js-filter");
        let projects = document.querySelectorAll(".project");

        filters.forEach(filter => {
            filter.addEventListener("click", (event) => {
                event.preventDefault();
                filterProjects(event);
            })
        })

        function filterProjects(e) {
            e.preventDefault();
            for (var eachFilter of filters) {
                eachFilter.classList.remove('text-rose-bud');
            }

            e.target.classList.add('text-rose-bud')

            let filter = e.target.dataset.filter;
            for (var project of projects) {
                if (filter == "all") {
                    project.style.display = "initial";
                    project.classList.add("text-rose-bud");
                }
                else if (project.classList.contains(filter)) {
                    project.style.display = "initial";
                    project.classList.add("text-rose-bud");
                }
                else {
                    project.style.display = "none";
                }
            }
        }
    }
}
customElements.define('card-filter', CardFilter);
